import { DragDropContext, Droppable, DropResult } from "@hello-pangea/dnd";
import { RefreshIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonSize, ButtonVariant, Show } from "shared/components";
import { NavItemId, NavSectionId } from "../constants";
import { useNavItemCounts } from "../use-nav-item-counts";
import { useNavCustomization } from "../use-nav-customization";
import { CustomizeNavRow } from "./CustomizeNavRow";
import { NavSectionHeader } from "./NavSectionHeader";

export const CustomizeNavSections = () => {
  const { sections, isDefault, moveItem, reset } = useNavCustomization();
  const counts = useNavItemCounts({
    isInboxEnabled: sections.some(({ items }) =>
      items.some(({ id }) => id === NavItemId.INBOX)
    ),
    isUnitsEnabled: sections.some(({ items }) =>
      items.some(({ id }) => id === NavItemId.UNITS)
    )
  });

  const handleDragEnd = ({ source, destination }: DropResult) => {
    if (!destination || destination.droppableId !== source.droppableId) return;
    if (destination.index === source.index) return;

    moveItem(
      source.droppableId as NavSectionId,
      source.index,
      destination.index
    );
  };

  return (
    <>
      {sections.map((section) => (
        <div key={section.id} className="mb-3 px-4">
          <NavSectionHeader section={section} isAlwaysVisible />
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId={section.id}>
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {section.items.map((item, index) => (
                    <CustomizeNavRow
                      key={item.id}
                      item={item}
                      index={index}
                      count={counts.get(item.id) ?? 0}
                    />
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      ))}
      <Show if={!isDefault}>
        <div className="flex justify-center pb-1 pt-3">
          <Button
            variant={ButtonVariant.BASE}
            size={ButtonSize.XS}
            borderLess
            HugeIcon={RefreshIcon}
            onClick={reset}
          >
            Reset to default
          </Button>
        </div>
      </Show>
    </>
  );
};
